import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
];

export default routes
